import { render, staticRenderFns } from "./IconMinimize2.vue?vue&type=template&id=28401756"
import script from "./IconMinimize2.vue?vue&type=script&lang=js"
export * from "./IconMinimize2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports